export const LAST_OUTGOING_CHANNEL_MESSAGE_ID = 'LAST_OUTGOING_CHANNEL_MESSAGE_ID';